export const UnableToCompleteStatus = {
  PARTIALLY: 'partially',
  FULLY: 'fully'
} as const;

type UnableToCompleteStatusType = (typeof UnableToCompleteStatus)[keyof typeof UnableToCompleteStatus];

export const unableToCompleteStatusToLabel: Record<UnableToCompleteStatusType, string> = {
  [UnableToCompleteStatus.PARTIALLY]: 'Partially',
  [UnableToCompleteStatus.FULLY]: 'Fully'
} as const;
